// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3fNOV","basic":"Button_basic__3QX6j","fullWidth":"Button_fullWidth__1exh2","disabled":"Button_disabled__2RgMt"};